import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Checkbox, Col, Form, FormField, Row, Table } from "elemental-react16"
import { Button, Icon, Message } from "semantic-ui-react"
import { withRouter } from "react-router"
import "style/CheckoutPage.scss"
import Price from "components/Price/Price"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import shop from "shop/shop"
import ProductTable from "components/Product/ProductTableReadOnly"
import track from "shop/track"
import WordPressContainer from "WordPressContainer"

@withRouter
class ConfirmationPage extends Component {
  constructor() {
    super()
    this.state = {
      show   : false,
      cart   : shop.cart,
      agb    : false,
      privacy: false
    }
    shop.cart.hooks.changed.add( this.update )
  }
  
  update = ( cart ) => {
    this.setState( { cart } )
  }
  
  componentDidMount() {
    track.checkout( { step: 3, products: shop.cart.products } )
  }
  
  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.update )
  }
  
  handleEnquiry = () => {
    shop.cart.setExtra( "is_quotation_request", true )
    this.props.history.push( "../success/" )
  }
  
  handleSubmit = async () => {
    shop.cart.setExtra( "is_quotation_request", false )
    this.props.history.push( "../success/" )
  }
  
  handleAgb = ( agb ) => {
    console.log( `agb`, agb )
    this.setState( { agb } )
  }
  
  handleDatenschutz( privacy ) {
    this.setState( { privacy } )
  }
  
  toHome = () => {
    this.props.history.push( "/home" )
  }
  
  render() {
    let { agb, privacy } = this.state
    
    let manual_order_id = shop.cart.getExtra( "manual_order_id" )
    let attachments = shop.cart.getExtra( "attachments" )
    let { comment, deliveraddress, deliverdate } = shop.cart.data
    let billingAddress = shop.session.value
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    const canOrder = !agb || shop.cart.sum <= shop.config.MIN_ORDER_VALUE
    const { hasDeliveryAddress } = shop.cart
    const tax = shop.cart.sum / 100 * Number( shop.config.taxRate )
    const hasTax = shop.config.taxRate
    return (
      <div className="pb4">
        <HeaderCheckout activeStep={2}/>
        
        <div className="container ">
          {/*<Link to="/checkout/delivery"> <Button > <i className="icon-angle-left"/> Zurück </Button></Link>*/}
          <section>
            
            <div className="row-title tl">
              <h2>{translate( "your data" )}</h2>
            </div>
            
            <div className="pb3">
              <Row>
                {(manual_order_id !== undefined) &&
                <Col md="1/5" className=""><span className="black-50">{translate( "manual_order_id" )}</span>
                  <div className="pt3">
                    <p className="mb4">{manual_order_id}</p>
                  </div>
                </Col>}
                <Col md="1/5" className=""><span className="black-50">{translate( "billing address" )} </span>
                  <div className="pt3">
                    <strong> {billingAddress.title}</strong> <br/>
                    {billingAddress.street} <br/>
                    {billingAddress.pcode} {billingAddress.city}<br/>
                    {billingAddress.country}<br/>
                  </div>
                </Col>
                <Col md="1/5" className=""><span className="black-50">{translate( "delivery address" )} </span>
                  <div className="pt3">
                    {!hasDeliveryAddress && <div className={"b"}>{translate( "billing address" )}</div>}
                    {deliveraddress && <div className="mb4">
                      <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                      {deliveraddress.street}<br/>
                      {deliveraddress.pcode} {deliveraddress.city}<br/>
                      {deliveraddress.country}<br/>
                    </div>
                    }
                  </div>
                </Col>
                <Col md="1/5" className=""><span className="black-50">{translate( "payment" )}</span>
                  <div className="pt3">
                    <strong>{translate( "as agreed on" )}</strong>
                  </div>
                </Col>
                <Col md="1/5" className=""><span className="black-50">{translate( "your comment" )}
                  <div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
              </span></Col>
                
                
                {deliverdate &&
                <Col md="1/5" className=""><span className="black-50">{translate( "delivery after" )}
                  <div className="pt3">
                  <p className="mb4">{deliverdate}</p>
              </div>
              </span></Col>}
              
              </Row>
            </div>
          
          </section>
          
          
          <section>
            
            {attachments && <Row>
              <Col>
                <div className="row-title tl">
                  <h2>{translate( "attachments" )}</h2>
                </div>
                <p><strong>Logo ID</strong>: {attachments}</p>
              </Col>
            </Row>}
          </section>
          
          
          <section className="overflow-hidden pt3">
            <div className="row-title tl">
              <h2>{translate( "order items" )}</h2>
            </div>
            
            <ProductTable cart={shop.cart} onChange={this.handleChange} products={getProducts()}/>
            <Table style={{ maxWidth: "320px" }} className="fr">
              <thead>
              
              <tr>
                <td className="tr" colSpan="2">
                  <span className="black-50 f5"><strong>{shop.cart.size} {translate( "positions" )} </strong></span>
                </td>
              </tr>
              
              <tr>
                <td><span className="f4 b black">{translate( "Summe" )}</span></td>
                <td className="f4 b black tr"><Price>{shop.cart.sum}</Price></td>
              </tr>
              
              
              {/* DISCOUNTS!*/}
              {(shop.session.handId && !!shop.cart.sumDiscount) &&
              <React.Fragment>
                <tr className={"black-60 f5"}>
                  <td>{translate( "Discount" )}</td>
                  <td className="tr"><Price>{shop.cart.sumDiscount}</Price></td>
                </tr>
                
                <tr>
                  <td><strong>{translate( "nach Rabatt" )}</strong></td>
                  <td className="tr"><Price>{shop.cart.sum - shop.cart.sumDiscount}</Price></td>
                </tr>
              </React.Fragment>
              }
              
              
              </thead>
              <tbody>
              {hasTax && <tr>
                <td><span className="f5  ">{translate( "zzgl. Steuern" )} ({shop.config.taxRate.replace( ".", "," )}%)</span></td>
                <td className="f5   tr"><Price>{tax}</Price></td>
              </tr>}
              
              {hasTax && <tr>
                <td><span className="f5 b black">{translate( "inkl. Steuern" )}</span></td>
                <td className="f5 b  tr"><Price>{tax + shop.cart.sum}</Price></td>
              </tr>}
              </tbody>
            </Table>
          
          </section>
          
          
          <section>
            <div className="mv3">
              <WordPressContainer
                className={"ui message mb3"}
                slug={"confirmation-notice"} postType={"shop"}/>
            </div>
          </section>
          
          <section>
            <div className="row-title tl">
              <h2>{translate( "Abschluss" )}</h2>
            </div>
            
            <div className="tr">
              <Form type="horizontal">
                <FormField>
                  {!agb && <div className="cf dib pb2">
                    <Message negative className="">
                      <div className="total ">
                        <div className="ph3">
                          <Icon name="info"/>{translate( "please confirm our general terms" )}
                        </div>
                      </div>
                    </Message>
                  </div>}
                  
                  <div className="tr"><Link target="_blank"
                                            to="/cms/agb">{translate( "AGB" )}</Link><br/></div>
                  <Checkbox value={agb} onChange={( e ) => this.handleAgb( e.target.checked )}
                            label={translate( "I accept the general terms and conditions" )}/>
                </FormField>
                
                {shop.config.useAdditionalDeliveryNotice && <FormField>
                  <div className={"pv3"}>
                    <div className="b f6 ttu pb2">Lieferhinweis</div>
                    <div>Bestellung über 350€ à Frei Haus</div>
                    <div>Bestellung zwischen 350€ und 100€ à 6,95€ Porto</div>
                    <div>Bestellungen unter 100€ à Porto + 10€ Mindermengenzuschlag</div>
                  </div>
                </FormField>}
                
                <FormField>
                  
                  {!privacy && <div className="cf dib pb2">
                    <Message negative className="">
                      <div className="total ">
                        <div className="ph3">
                          <Icon name="info"/>{translate( "please confirm our privacy information" )}
                        </div>
                      </div>
                    </Message>
                  </div>}
                  
                  <div className="tr"><Link target="_blank"
                                            to="/cms/datenschutz">{translate( "Datenschutzerklärung" )}</Link><br/>
                  </div>
                  <Checkbox value={privacy}
                            onChange={( e ) => this.handleDatenschutz( e.target.checked )}
                            label={translate( "privacy_notice_notice" )}/>
                
                </FormField>
              
              
              </Form>
            </div>
            
            {shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
            <div className="cf pb2">
              <Message negative className="">
                <div className="total ">
                  <div className="ph3">
                    <Icon name="info"/>{translate( "minimum order value not reached" )}
                    <span className="pull-right">
                    <Price>{shop.config.MIN_ORDER_VALUE}</Price>
                  </span>
                  </div>
                </div>
              </Message>
            </div>
            }
            
            
            {!isRequest &&
            <Button
              className="fr"
              disabled={canOrder}
              primary
              onClick={this.handleSubmit}
              style={{
                paddingLeft : "32px",
                paddingRight: "32px"
              }}>{translate( "order now" )}</Button>}
            
            {isRequest &&
            <Button
              className="fr"
              primary
              disabled={canOrder}
              onClick={this.handleEnquiry}
              style={{
                paddingLeft : "32px",
                paddingRight: "32px"
              }}>{translate( "send enquiry" )}</Button>}
          </section>
        </div>
      </div>
    
    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product )
export default ConfirmationPage



// WEBPACK FOOTER //
// ./src/theme/inware/pages/checkout/ConfirmationPage.js